import React from "react";
import Banner from "./Banner";
import Footer from "./Footer";
import ScrollTrigger from "react-scroll-trigger";

const Company_About = () => {
  return (
    <>
      <Banner />
      <div className="home_header">
        <h1 className="home_header">ABOUT TIME CYBER MEDIA</h1>
      </div>
      <div className="company_info">
        <p>
          Our main focus is to accelerate profitable brand development for our
          clients and to re-invent market research through our services. We
          cater to a varied client-
          <br />
          base, ranging from government bodies and NGOs to corporates and
          start-ups. A business needs a character and an identity, and through
          our branding and
          <br />
          brand development services we help them create it by turning their
          name into a leading brand that has a convincing voice and brand image.
          The brand image
          <br />
          is the essence of the business/product and branding is assembling the
          various marketing mediums into a whole so as to give the business a
          definitive identity.
          <br />
          We offer comprehensive services that define, develop and implement the
          brand identity by communicating the message eloquently and
          effectively. TIME
          <br />
          Cyber Media also offers evaluations and research- analysis services
          that are driven by our high industry standard measures and credible
          reputation with
          <br />
          access to a large clientele and customer base. Our ratings, rankings
          and accreditations provide a gradient along which performance and
          value of the
          <br />
          businesses is measured against global business benchmarks. We offer a
          complete package of media solutions and profiling as well as
          consulting,\
          <br />
          promotions, marketing and advertising. Our services include: brand
          management, business strategy and advisory, market research, data
          analysis, business
          <br />
          solutions, public relations, media and communication, digital
          marketing and consultancy services. We also organize exhibitions,
          award events, conference
          <br />
          and seminar to nurture, encourage and promote innovation and talent.
          Our main office is located in New Delhi.
        </p>
      </div>
      <Footer />
    </>
  );
};

export default Company_About;
